module.exports = __webpack_public_path__ + "img/preview-chat.ff175625.png";